import {
    Drawer,
    makeStyles,
    Theme,
    createStyles,
    useTheme,
    IconButton,
    Divider,
    ListItemIcon,
    ListItemText,
    MenuList,
    MenuItem,
    Icon,
} from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import React from 'react';
import { getGlobal } from 'reactn';
import { ActionWithAuthorization } from '../../auth/KeycloakState';
import { CAN_CREATE, CAN_VIEW } from '../../shared/constants/AuthConstants';
import RouteLink from '../../router/RouteLink';

const drawerWidth = 240;

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: 'flex',
        },
        appBar: {
            transition: theme.transitions.create(['margin', 'width'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
        },
        appBarShift: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
            transition: theme.transitions.create(['margin', 'width'], {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
        },
        menuButton: {
            marginRight: theme.spacing(2),
        },
        hide: {
            display: 'none',
        },
        drawer: {
            width: drawerWidth,
            flexShrink: 0,
        },
        drawerPaper: {
            width: drawerWidth,
        },
        drawerHeader: {
            display: 'flex',
            alignItems: 'center',
            padding: theme.spacing(0, 1),
            ...theme.mixins.toolbar,
            justifyContent: 'flex-end',
        },
        content: {
            flexGrow: 1,
            padding: theme.spacing(3),
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            marginLeft: -drawerWidth,
        },
        contentShift: {
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
            marginLeft: 0,
        },
    }),
);

function getActionsAllowed() {
    return [
        getGlobal().keycloakState.getActionsAllowed([
            {
                name: 'add',
                icon: 'add-box',
                title: 'New Configuration',
                url: '/add-configuration',
                authorizationNeeded: CAN_CREATE,
            },
            {
                name: 'list',
                icon: 'list',
                title: 'List Configurations',
                url: '/',
                authorizationNeeded: CAN_VIEW,
            },
        ]),
        getGlobal().keycloakState.getActionsAllowed([
            {
                name: 'history',
                icon: 'history',
                title: 'Audit Trails',
                url: '/audit-trails',
                authorizationNeeded: CAN_CREATE,
            },
        ]),
    ];
}

function AppDrawer(props: { handleDrawerClose: () => void; open: boolean }) {
    const classes = useStyles();
    const theme = useTheme();

    return (
        <Drawer
            className={classes.drawer}
            variant="temporary"
            anchor="left"
            open={props.open}
            classes={{
                paper: classes.drawerPaper,
            }}
            ModalProps={{ onBackdropClick: props.handleDrawerClose, onEscapeKeyDown: props.handleDrawerClose }}
        >
            <div className={classes.drawerHeader}>
                <IconButton onClick={props.handleDrawerClose}>
                    {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                </IconButton>
            </div>
            {getActionsAllowed().map((actions) => {
                return (
                    <div>
                        <Divider />
                        <MenuList>
                            {actions.map((action: ActionWithAuthorization) => {
                                return (
                                    <RouteLink
                                        to={action.url}
                                        onClick={props.handleDrawerClose}
                                        style={{ textDecoration: 'none' }}
                                        key={action.title}
                                    >
                                        <MenuItem button key={action.title}>
                                            <ListItemIcon>
                                                <Icon>{action.icon}</Icon>
                                            </ListItemIcon>
                                            <ListItemText primary={action.title} />
                                        </MenuItem>
                                    </RouteLink>
                                );
                            })}
                        </MenuList>
                    </div>
                );
            })}
        </Drawer>
    );
}

export default AppDrawer;
